export default "__VITE_ASSET__D0Mloriu__"